import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import { selectUser, clearSelectedUser } from '../../actions'
import { Translation } from 'react-i18next'
import { Autocomplete } from '@material-ui/lab'
import { useDispatch } from 'react-redux'

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    height: theme.spacing(2),
    minWidth: 300
  },
  container: {
    position: 'relative',
    minWidth: 300,
    border: '1px solid gray'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    maxHeight: '70px',
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  option: {
    marginTop: '4px',
    marginBottom: '4px',
    fontSize: '12px'
  }
})

const RenderAutoNameSuggest = (props) => {
  const {
    classes,
    options,
    // disabled,
    setDisabled,
    value,
    setValue,
    selectedEmail
  } = props

  const dispatch = useDispatch()

  const [inputValue, setInputValue] = React.useState(selectedEmail ?? '')

  function renderInputComponent(params) {
    const props = { ...params }
    props.InputProps = {
      style: { fontSize: '14px' },
      ...params.InputProps
    }
    return (
      <Translation>
        {(t) => {
          return <TextField placeholder={t('EmailReq')} fullWidth {...props} />
        }}
      </Translation>
    )
  }

  // const handleClear = () => {
  //   this.setState({ filteredSuggestions: [] })
  // }

  const handleSuggestionSelected = (event, option) => {
    if (option) {
      setValue(options.findIndex((el) => el.email === option.email))
      setInputValue(option.email)
      dispatch(selectUser(option.email))
      setDisabled(true)
    } else {
      dispatch(clearSelectedUser())
      setValue(null)
      setInputValue('')
    }
  }

  function onInputChange(event, value, reason) {
    if (reason === 'input') {
      dispatch(clearSelectedUser())
      setValue(null)
      setInputValue(value)
    }
  }

  return (
    <div className={classes.root}>
      <Autocomplete
        value={value}
        inputValue={inputValue}
        options={options}
        renderInput={renderInputComponent}
        getOptionLabel={(option) => {
          return option.email ?? ''
        }}
        getOptionSelected={(option, val) =>
          !!(val === value && option.email === inputValue)
        }
        onChange={handleSuggestionSelected}
        // disabled={disabled}
        // disableClearable={true}
        onInputChange={onInputChange}
        classes={{
          option: classes.option
        }}
      />
    </div>
  )
}

RenderAutoNameSuggest.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(RenderAutoNameSuggest)
